module.exports = __webpack_public_path__ + "static/img/icon_wechat@2x.083f565.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/contactUs/contactInfo/icon_wechat@2x.png
// module id = aX4B
// module chunks = 0